import { Button, Input, Modal, Select } from "antd";

const Option = Select.Option;

export default function CreateTag({ props }) {
  return (
    <>
      <div className="pb-3 pr-0 w-fit">
        <Button type="primary" onClick={props.toggleVisibility}>
          Create Tag
        </Button>
      </div>

      <Modal
        visible={props.visibility}
        title="Create New Tag"
        onOk={props.toggleVisibility}
        onCancel={props.toggleVisibility}
        footer={[
          <Button key="back" onClick={props.toggleVisibility}>
            Return
          </Button>,
          <Button
            type="primary"
            key="submit"
            className="btn btn-success"
            loading={props.loading}
            onClick={props.createNewTag}
          >
            Submit
          </Button>,
        ]}
      >
        <div className="p-2">
          <span>Tag Name</span>
          <Input
            value={props.name}
            onChange={(e) => props.setName(e.target.value)}
            placeholder={"Input Name"}
          />
        </div>

        <div className="p-2">
          <span>Tag Type</span>
          <Select
            showSearch
            className="w-100percent ant-input mn-150"
            size="default"
            value={props.tagType}
            onChange={(e) => {
              props.setTagType(e);
            }}
            placeholder={"Select Tag Type"}
          >
            <Option value={"USER"}>USER</Option>
            <Option value={"ACCESSGROUP"}>ACCESSGROUP</Option>
            <Option value={"COURSE"}>COURSE</Option>
          </Select>
        </div>
      </Modal>
    </>
  );
}
